"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutProductsInfo = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const ui_1 = require("@obvio/ui");
const CheckoutContext_1 = require("../../CheckoutContext");
const OrderProductsInfo_1 = require("../../OrderTemp/views/OrderProductsInfo");
function CheckoutProductsInfo({ products, vouchers, }) {
    var _a, _b;
    const { getValue } = (0, ui_1.useFormContext)();
    const { shippingMethods } = (0, CheckoutContext_1.useCheckout)();
    const shipping = getValue('shipping');
    const paymentMethod = getValue('paymentMethod');
    const method = shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods.find((v) => v.id === shipping);
    const shippingValue = method ? method.price.amount : 0;
    const deliveryPrice = paymentMethod === 'ON_DELIVERY' && method
        ? (_b = (_a = method.onDeliveryPrice) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0
        : 0;
    return ((0, jsx_runtime_1.jsx)(OrderProductsInfo_1.OrderProductsInfo, { products: products, vouchers: vouchers, shipping: shippingValue + deliveryPrice }));
}
exports.CheckoutProductsInfo = CheckoutProductsInfo;
